import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMessageResultsFromStagedThread } from '../quick-reply/operators/getMessageResultsFromStagedThread';
import getQuickReplyOptionsFromStagedThreadMessages from '../quick-reply/operators/getQuickReplyOptionsFromStagedThreadMessages';
import { showQuickReplyOutsideChat } from '../utils/showQuickRepliesOutsideChat';
import { selectQuickReplyOptionOutsideChat } from '../actions/selectQuickReplyOptionOutsideChat';
import { getColoring } from '../selectors/widgetDataSelectors/getColoring';
import { getIsUngatedForUpdatedChatLauncherExperience } from '../widget-data/selectors/widgetDataSelectors';
export const useWelcomeMessageQuickReplies = () => {
  const dispatch = useDispatch();
  const isUngatedForUpdatedLauncher = useSelector(getIsUngatedForUpdatedChatLauncherExperience);
  const messageResults = useSelector(getMessageResultsFromStagedThread);
  const quickReplyOptions = getQuickReplyOptionsFromStagedThreadMessages(messageResults);
  const displayBotQuickRepliesOutsideChat = useSelector(showQuickReplyOutsideChat);
  const widgetColoring = useSelector(getColoring);
  const handleQuickReplyClick = useCallback((text, quickReply) => {
    dispatch(selectQuickReplyOptionOutsideChat(text, quickReply));
  }, [dispatch]);
  const showQuickReplies = isUngatedForUpdatedLauncher && displayBotQuickRepliesOutsideChat && quickReplyOptions.size > 0;
  const quickRepliesConfig = useMemo(() => showQuickReplies ? {
    quickReplyOptions,
    onQuickReplyClick: handleQuickReplyClick,
    accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor
  } : undefined, [showQuickReplies, quickReplyOptions, handleQuickReplyClick, widgetColoring]);
  return {
    showQuickReplies,
    quickRepliesConfig
  };
};